import React from 'react';
import '../less/salary-project.less';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.webp';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import double_salary_banner_img from '../img/double_salary_banner_img.webp';
import BusinessOrder from '../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import additionalCards01 from '../enums/additional_cards_01_data.json';
import additionalCards02Data from '../enums/additional_cards_02_data.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import entrepreneurs_top_img from '../img/entrepreneurs_top_img.webp';
import employees_top_img from '../img/employees_top_img.webp';
import entrepreneursTopBlockItems from '../enums/entrepreneurs_top_block.json';
import employeesTopBlockItems from '../enums/employees_top_block.json';
import DOMPurify from 'utils/sanitize';
import ButtonStorybook from '@abank/abank-button';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";

export default function template() {
  const tabs = [{tab: 'entrepreneurs', title: 'SALARY_PROJECT_NEW_TABS_TITLE_01'},
          {tab: 'employees', title: 'SALARY_PROJECT_NEW_TABS_TITLE_02'}];

  const handlersMap = {
    toggleModal: () => this.toggleModal()
  };

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      onClick: handlersMap[hero_data.link.onClick],
    },
  };

  const additionalCards02 = additionalCards02Data.map(item => ({
    ...item,
    onClick: handlersMap[item.onClick]
  }));

  const renderTopBlock = (img, items) => (
    <div className="top-block">
      <div className="container">
        <div className="top-block__body">
          <div className="top-block__left">
            <img className="top-block__image" src={img} alt="" />
          </div>
          <ul className="top-block__right">
            {items.map(item => (
              <li className="top-block__item item-top-block" key={item.title}>
                <h2 className="item-top-block__title" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.title))}}></h2>
                <p className="item-top-block__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.text))}}></p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');
  const filesWidget = this.widgetsHelper.getWidget.call(this, 'files_to_download');

  return (
    <div className="salary-project-new">
      <Hero
        data={heroData}
        img={hero_img}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <section className='double-salary-banner' aria-labelledby='double-salary-banner-title'>
          <div className="container">
            <div className='double-salary-banner__body'>
              <img className='double-salary-banner__image' src={double_salary_banner_img} alt={this.l10n('SALARY_PROJECT_NEW_DOUBLE_SALARY_BANNER_IMG_ALT')} />
              <div className='double-salary-banner__left'>
                <h2 className='double-salary-banner__title' id='double-salary-banner-title'>{this.l10n('SALARY_PROJECT_NEW_DOUBLE_SALARY_BANNER_TITLE')}</h2>
                <p className='double-salary-banner__text'>{this.l10n('SALARY_PROJECT_NEW_DOUBLE_SALARY_BANNER_TEXT')}</p>
                <ButtonStorybook
                  className="double-salary-banner__link"
                  label={this.l10n('SALARY_PROJECT_NEW_DOUBLE_SALARY_BANNER_LINK')}
                  {...getSafeLinkProps('/special_offers/double_salary', {navigate: this.navigate})}
                  size={"medium"}
                />
                <p className='double-salary-banner__dates'>{this.l10n('SALARY_PROJECT_NEW_DOUBLE_SALARY_BANNER_DATES')}</p>
              </div>
            </div>
          </div>
        </section>
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
          {renderTopBlock(entrepreneurs_top_img, entrepreneursTopBlockItems)}
          {renderTopBlock(employees_top_img, employeesTopBlockItems)}
        </Tabs>
        <AdditionalProduct
          items={additionalCards01}
          title={'SALARY_PROJECT_NEW_ADDITIONAL_PRODUCT_01_TITLE'}
        />
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'SALARY_PROJECT_NEW_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
        <AdditionalProduct
          items={additionalCards02}
          itemTitleTag={"h2"}
          className="additional-product_2"
        />
        <FilesForDownloadNew
          widget={filesWidget}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('SALARY_PROJECT_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('SALARY_PROJECT_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      {this.state.showModal && <BusinessOrder attribute="salary-project" closeModal={this.toggleModal} />}
    </div>
  )
}
